module.exports = __webpack_public_path__ + "static/img/dadibanner2.99dc272.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/haierProduct/images/dadibanner2.jpg
// module id = aIwq
// module chunks = 4